import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';

export function FooterBackToTop({ classes }) {
  const onBackToTopClick = useCallback(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_RESET_NAVIGATION,
        subaction_name: TrackingConstant.JUMP_TO_TOP,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        synpartner: TrackingConstant.SYNPARTNER,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: undefined,
        value: 'footer',
      },
    });
  }, []);

  return (
    <ScrollLink
      to="main-content"
      className={classnames(
        'footer-to-top pos-r btn btn-outline-blue-30 fw-medium text-blue-30 px-1 py-0_5 mb-0_5 mb-md-0',
        classes
      )}
      rel="nofollow"
      onClick={onBackToTopClick}
      data-tracking-id="back_to_top"
      data-tracking-value="top"
    >
      Back to Top
      <i
        className="icon icon-arrow-up3 text-primary-darker size-16 ms-0_5"
        style={{ width: '1rem', height: '1rem' }}
        aria-hidden
      />
    </ScrollLink>
  );
}

FooterBackToTop.propTypes = {
  classes: PropTypes.string,
};

FooterBackToTop.defaultProps = {
  classes: null,
};
